module.exports = __webpack_public_path__ + "img/Sozo_TC.92ba265a.png";